import { render, staticRenderFns } from "./TrainingDatesDetails.vue?vue&type=template&id=19bf80b6&"
import script from "./TrainingDatesDetails.vue?vue&type=script&lang=js&"
export * from "./TrainingDatesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports